/* Marimi pe card (30 iul 2026): fade la capat + glisare cu mouse-ul; pe touch scrollul e nativ */
(function () {
  function upd(el) {
    var w = el.parentElement;
    w.classList.toggle('ovf', el.scrollWidth > el.clientWidth + 2);
    w.classList.toggle('at-end', el.scrollLeft + el.clientWidth >= el.scrollWidth - 2);
  }
  function all() { document.querySelectorAll('.wg-card-sizes').forEach(upd); }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('wg-card-sizes')) upd(t);
  }, true);
  window.addEventListener('resize', all);
  var mo = new MutationObserver(function () {
    clearTimeout(mo._t);
    mo._t = setTimeout(all, 150);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var el = e.target.closest && e.target.closest('.wg-card-sizes');
    if (!el || el.scrollWidth <= el.clientWidth) return;
    drag = { el: el, x: e.clientX, sl: el.scrollLeft, moved: false };
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 4) drag.moved = true;
    if (drag.moved) { drag.el.scrollLeft = drag.sl - dx; e.preventDefault(); }
  }, true);
  ['pointerup', 'pointercancel'].forEach(function (t) {
    document.addEventListener(t, function () { drag = null; }, true);
  });
  if (document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', all);
})();
